//This is an axios response object that contains a downloaded file
function fileToDownload (response, filename) {
    var blob = new Blob([response.data], { type: response.headers['content-type'] })
    var link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = filename
    link.click()
}

export default {
    fileToDownload: fileToDownload
}
